import { createSlice } from "@reduxjs/toolkit";
import { collapseKey, firstTrackOfRole } from "./helpers";
const initialState = {};
const optimistSlice = createSlice({
    name: "optimist",
    initialState,
    reducers: {
        toggleErrorsOnly: (state, _action) => {
            state.errorsOnly = !state.errorsOnly;
        },
        toggleErrorFilter: (state, action) => {
            const error = action.payload;
            const filters = new Set(state?.errorFilters ?? []);
            if (filters.has(error)) {
                filters.delete(error);
            }
            else {
                filters.add(error);
            }
            state.errorFilters = Array.from(filters);
        },
        toggleTrackFilter: (state, action) => {
            const track = action.payload;
            const visible = !state.trackFilters[track];
            state.trackFilters[track] = visible;
            if (state.selectedTrackId === track && !visible) {
                state.selectedTrackId =
                    firstTrackOfRole(state.report.tracks, state.role, state.trackFilters) ?? state.selectedTrackId;
            }
        },
        setRole: (state, action) => {
            state.role = action.payload;
            state.selectedTrackId =
                firstTrackOfRole(state.report.tracks, state.role, state.trackFilters) ??
                    state.selectedTrackId;
        },
        togglePanelCollapse: (state, action) => {
            const { creditManager, creditAccount, opened } = action.payload;
            let cm = creditManager;
            if (!cm) {
                // find account
                const r = state.report.results.find(r => r.account.toLowerCase() === creditAccount?.toLowerCase());
                cm = r?.creditManager;
            }
            if (!cm) {
                return;
            }
            const key = collapseKey(cm, creditAccount);
            const oldValue = state.collapsedPanels[key];
            const newValue = opened === undefined ? !oldValue : opened;
            state.collapsedPanels[key] = newValue;
            // when opening credit account, make sure to open credit manager too
            if (creditAccount && newValue) {
                state.collapsedPanels[cm.toLowerCase()] = newValue;
            }
        },
        setSelectedTrackId: (state, action) => {
            state.selectedTrackId = action.payload;
        },
    },
});
export const optimistReducer = optimistSlice.reducer;
export const optimistActions = optimistSlice.actions;
